import {FC} from 'react';

import {PropertyRulesItem} from '@stencil/hotels-cg-reducer/src/details/types';
import {getIconFromName} from '@stencil/hotels-utils/src/name-to-icon-map-food';

import * as S from './PropRules.styles';

interface PropRulesProps {
  heading: string;
  data: PropertyRulesItem[];
}

const PropRules: FC<PropRulesProps> = ({heading, data}) => {
  return (
    <S.Rules>
      {heading && <span className="rule_heading">{heading}</span>}
      {data && data.length > 0 && (
        <ul>
          {data.map((item, index) => (
            <li key={index.toString()}>
              {item.icon && <span className="rlIcon">{getIconFromName(item.icon)}</span>}
              {item.text && <span>{item.text}</span>}
            </li>
          ))}
        </ul>
      )}
    </S.Rules>
  );
};
export default PropRules;
